import useGithubContributors from "../../../hooks/useGithubContributors";

export default function ContributorAvatars({ owner, repo }) {
  const { contributors } = useGithubContributors(owner, repo);
  if (!contributors.length) return null;
  const shown = contributors.slice(0, 4);
  const extra = contributors.length - shown.length;

  return (
    <div className="flex items-center -space-x-3">
      {shown.map((c) => (
        <div key={c.login} className="group relative">
          <a
            href={c.html_url}
            target="_blank"
            rel="noopener noreferrer"
            className="
            relative shrink-0
        block h-9 w-9
        overflow-hidden
        rounded-full
        border-2 border-white
        bg-[#222]
        transition-transform
        duration-200
        hover:z-10
        hover:scale-110
      "
          >
            <img
              src={c.avatar_url}
              alt={c.login}
              className="h-full w-full object-cover"
            />
          </a>

          <span
            className="
        pointer-events-none
        absolute left-1/2 top-full z-20
        mt-1
        -translate-x-1/2
        whitespace-nowrap
        rounded
        bg-black px-1.5 py-0.5
        text-[9px] text-white
        opacity-0
        transition-opacity duration-200
        group-hover:opacity-100
      "
          >
            {c.login}
          </span>
        </div>
      ))}
      {extra > 0 && (
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-white bg-[#1a1a1a] text-[10px] text-[#999]">+{extra}</div>
      )}
    </div>
  );
}